module.exports = __webpack_public_path__ + "static/tacoma2-b870eae3631974fa238512f729250870.png";